import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Table } from "antd";
import VisitStatusDropdown from "./visitStatusDropdown";
import MainLayout from "../../Layout/mainLayout";
import { columnsSiteVisit, columnsHomeVisit } from "../../Global Functions/columnsAntd";
import { listSiteVisits, listHomeVisits } from "../../Redux/Actions/franchiseManagerAction";
import ListTopSearch from "../../Global Functions/listTopSearch";
import DateRangePopup from "../../Utils/dateFilterPopup";
import "./listFranchiseManager.css";
import toast from "react-hot-toast";

const STATUS_OPTIONS = {
    site: ["requested", "booked", "started", "ongoing", "completed", "cancelled"],
    home: ["requested", "accepted", "ontheway", "ongoing", "completed", "declined", "cancelled"],
};

const ListVisits = ({ type }) => {
    const dispatch = useDispatch();
    const { franchise_id, city_head_id, locality_head_id } = useParams();
    const isSite = type === "site";

    const statusOptions = [
        { value: "", label: "All" },
        ...STATUS_OPTIONS[type].map((s) => ({
            value: s,
            label: s === "ontheway" ? "On The Way" : s.charAt(0).toUpperCase() + s.slice(1),
        })),
    ];

    const [status, setStatus] = useState("");
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });

    const {
        siteVisits, siteVisitPagination, homeVisits, homeVisitPagination, visitLoading,
    } = useSelector((state) => state.franchiseManager || {});

    const rows = isSite ? siteVisits : homeVisits;
    const apiPagination = isSite ? siteVisitPagination : homeVisitPagination;

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(async (page, pageSize) => {
        const payload = {
            page,
            limit: pageSize,
            franchisy_id: franchise_id,
            ...(city_head_id && { city_head: city_head_id }),
            ...(locality_head_id && { locality_head: locality_head_id }),
            ...(status && { status }),
            ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
            ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
        };
        try {
            await dispatch(isSite ? listSiteVisits(payload) : listHomeVisits(payload));
        } catch {
            toast.error("Failed to fetch list");
        }
        console.log("fetchDetails fired", { isSite, franchise_id, listSiteVisits, listHomeVisits });
    }, [dispatch, isSite, franchise_id, city_head_id, locality_head_id, status, dateRange]);

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize, fetchDetails]);

    useEffect(() => {
        if (apiPagination?.total !== undefined) {
            setPagination((prev) => ({ ...prev, total: apiPagination.total }));
        }
    }, [apiPagination]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, current: 1 }));
    }, [status, franchise_id, city_head_id, locality_head_id]);

    const handleTableChange = (pagination) => setPagination(pagination);

    const handleDateRangeApply = (start, end) => {
        setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const offset = (pagination.current - 1) * pagination.pageSize;
    const columns = useMemo(
        () => (isSite ? columnsSiteVisit(offset) : columnsHomeVisit(offset)),
        [isSite, offset]
    );

    return (
        <MainLayout>
            <div className="bookings_table">
                <div className="table_component_all">
                    <div style={{ gridColumn: "span 5", height: "auto" }}>
                        <ListTopSearch
                            h3heading={isSite ? "Site Visit List" : "Home Visit List"}
                            setState={() => { }}
                            buttonhead={null}
                            navigateTo={null}
                            onCalendarClick={() => setIsDatePopupVisible(true)}
                        />
                    </div>

                    <div className="custom_table">
                        <div style={{ padding: "0px 60px" }}>
                            <div style={{ position: "relative", zIndex: 20, margin: "-6.2% 0px 3% 87.7%" }}>
                                <VisitStatusDropdown
                                    value={status}
                                    onChange={setStatus}
                                    options={statusOptions}
                                />
                            </div>
                            <Table
                                dataSource={Array.isArray(rows) ? rows : []}
                                columns={columns}
                                pagination={pagination}
                                loading={visitLoading}
                                onChange={handleTableChange}
                                scroll={{ x: 1500, y: 500 }}
                                rowKey="_id"
                                rowClassName={() => "text-center"}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />
        </MainLayout>
    );
};

export default ListVisits;